/**
 * Tax – Create returns (VAT return wizard)
 */

export default {
  createReturns: {
    fillReturnParams: "Fill your return parameters",
    addVatNumber: `Please add your VAT number for country in 'VAT Registration' section`,
    reportPeriodsLoading: "Loading periods…",
    selectStateToLoadPeriods: "Select a state to load period options.",
    selectPeriodToContinue: "Please select a period to continue.",
    reasonReg: "Type of registration",
    discard: "Discard",
    next: "Next",
    vatReturn: "VAT Return",
    salesFromPrem: "Sales from premises",
    createVR: "Create VAT return",
    moss: "MOSS",
    createSalesList: "Create Sales List",
    vatRetCreated: "Your VAT return was created (country code: ",
    totalSum: ", total amount: ",
    warning: "Warning",
    country: "Country",
    period: "Period",
    assignedReportingPeriodicity: "Assigned reporting periodicity",
    year: "Year",
    q1: "1 quarter",
    q2: "2 quarter",
    q3: "3 quarter",
    q4: "4 quarter",
    jan: "January",
    feb: "February",
    mar: "March",
    apr: "April",
    may: "May",
    june: "June",
    july: "July",
    aug: "August",
    sept: "September",
    oct: "October",
    nov: "November",
    dec: "December",
    distSales: "Distant sales",
    revExVat: "Revenue (excluding VAT)",
    vatSum: "VAT amount",
    rates: {
      standard: "Standard rate",
      reduced: "Reduced rate",
      nonstandard: "Nonstandard rate",
      export: "Export",
    },
    addTransactionForGoodsRate: "Add transaction {{rate}} ({{percent}}%)",
    transactionFormForPercent: "Add transaction — {{percent}}% VAT",
    back: "Back",
    sum: "Amount",
    yes: "Yes",
    no: "No",
    buyFromSup1: "Did you buy your goods from supplier in",
    buyFromSup2: "",
    importOut: "Did you import your goods from outside the EU?",
    importChoiceCustoms: "VAT paid at Customs",
    importChoiceDeemed: "Deemed VAT",
    purchIn1: "Purchases in",
    purchIn2: "",
    import: "Import",
    buyFromEU1: "Did you buy your goods from EU supplier outside of",
    buyFromEU2: "",
    supplyB2b: "Did you supply goods to VAT–registered B2B customers?",
    intraCommAc: "Intra community acquisitions",
    ifYouFill: `You have several transactions with zero amount. Please add the amount for these intra-community transactions. Please note that transactions with zero amount wouldn't be included in your VAT return`,
    vatNumCust: "VAT Number of customer",
    valueOfPurchOut: "Value of purchases (without VAT)",
    valueOfPurch: "Value of purchases",
    goodsOrServ: "Goods or Services",
    noB2bAvail: "No b2b data available",
    addManually: "Add transactions manually",
    addFromFile: "Add transactions from file",
    orderSL: "Order Sales list report",
    upgradeForSL: "Please upgrade the subscription to order Sales list report.",
    checkForm:
      "Please check all the figures if you are agree you can fill in the form",
    salesList: "Sales list",
    forThePeriod: "For the period",
    for: " for",
    fillTheForm: "FILL THE FORM",
    delete: "Delete",
    date: "Date",
    negNumberNot: "Negative number is not allowed",
    planOver: "Your tarrif plan is over",
    contUsing: "You can continue using Lappa software when you subscribe.",
    selectPlan: "select plan",
    addRecord: "Add record",
    toTheFirst: "To the first step",
    willLose: "You will lose all entered data.",
    wantComeBack: "Do you want come back to the first step anyway?",
    countryCode: "country code",
    receivedReq: `We have well received your request of VAT return preparation.
    The VAT return will be in your account within 24 hours. You will be notified by email.`,
    changeSubPlan: "Change your subscription plan",
    returnParams: "Return parameters",
    outputVat: "Output VAT",
    inputVat: "Input VAT",
    advPayments: "Advance payments",
    intraComm: "Intra community",
    vatDue: "VAT due",
    numOfCust: "N of customs declaration",
    vatSumPayed: "VAT amount payed at customs",
    numOfInv: "Number of invoice",
    vatNumSupp: "VAT Number of supplier",
    rate: "Rate",
    dataEntered:
      "Data for this country and the tax rate have already been entered",
    vatDueSum: "Vat due summa",
    vatNumber: "VAT Number",
    vatReturnDetails: "VAT Return Details",
    amount: "Amount",
    boxOfUK: "Box # of UK VAT return",
    salesType: "Sales type",
    total: "Total",
    taxDue: "Tax due",
    err: "Error",
    addFile: "Add file",
    chooseFiles: "choose *.xlsx, *.xls files to upload",
    fileName: "file name",
    firstDataRow: "First data row number",
    lastDataRow: "Last data row number",
    chooseRows: "Choose first data and last data row",
    matchEach:
      "Match each column in your import file with system headers. Showing first data row from your file",
    uploadTrans: "Upload transactions",
    typeOfRep: "Type of report",
    currency: "Currency",
    description: "Description",
  },
};
